import React from 'react';

import { editAction, MediaActions } from '@/components/LegacyMediaContainer/hooks/useMediaList';
import { EntityMediaFragment } from '@/features/messages/graphql/fragments/generated/MediaType';

export enum MediaSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  AUTO = 'AUTO',
  ADJUST = 'ADJUST',
}

export type MediaCustomRendererProps = {
  media: EntityMediaFragment;
  onClick: (media: EntityMediaFragment) => void;
};

export interface MediaContainerProps {
  medias?: EntityMediaFragment[];
  display?: MediaDisplay;
  pdfClassName?: string;
  audioClassName?: string;
  videoClassName?: string;
  imageClassName?: string;
  size?: MediaSize;
  className?: string;
  mediaActions?: typeof editAction;
  onMediaAction?: (actionId: MediaActions, media: EntityMediaFragment) => void;
  isDownloadable?: boolean;
  user?: {
    name: string;
    profilePicture: string;
  };
  autoPlay?: boolean;
  openMediaPlayerOnLoad?: boolean | null;
  onMediaPlayerToggle?: (nextValue?: boolean) => void;
  height?: number;
  width?: number;
  renderWithOverlay?: (props: any) => React.ReactElement;
  actionListClassName?: string;
  onMediaProgress?: (media: EntityMediaFragment, progress: number) => void;
  onClose?: () => void;
  allowForwarding?: boolean;
  allowPlaybackSpeedControl?: boolean;
  initialProgress?: number;
  allowBackgroundVideoPlayback?: boolean;
}

export interface MediasProps {
  media: EntityMediaFragment & { progress?: number; previewUrl?: string | null; urlPreview?: any };
  onRemove?: () => void;
  className?: string;
  editable?: boolean;
  actions?: any[];
  size?: MediaSize;
  onAction?: (
    actionId: MediaActions,
    media: EntityMediaFragment,
    event: React.SyntheticEvent,
  ) => void;
  height?: number | string;
  width?: number | string;
  pdfClassName?: string;
  audioClassName?: string;
  videoClassName?: string;
  imageClassName?: string;
  onClick?: (media: EntityMediaFragment) => void;
  user?: {
    name: string;
    profilePicture: string;
  };
  actionListClassName?: string;
}

export interface MediaGridProps extends MediasProps {
  totalMedias: number;
  index: number;
}

export enum MediaDisplay {
  GRID = 'GRID',
  LIST = 'LIST',
}
